import { ViewChild, Component, HostListener, EventEmitter, Output, Input } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { Arena } from '../../../../model/arena';
import { AlertMessager } from '../../../../lib/alertMessager';
import { StockService } from '../../../../services/stock.service';
import { LoadingController, ToastController } from 'ionic-angular';

@Component({
    selector: 'search-box-v2',
    templateUrl: 'search-box.component.v2.html'
})
export class SearchBoxComponentV2 {
    @Input() itemTitle: string;
    @Output() itemSelected = new EventEmitter();
    @ViewChild('searchBox') searchBox;  

    searchChangeObservable;
    selecting: boolean = false;
    
    results: any = [];
    searchValue: string = '';
    selectedItem: Arena;

    loadingData: boolean = true;
    
    constructor(private alert: AlertMessager, private stockService: StockService, private loadingController: LoadingController, private toast: ToastController) {
    }

    public onSearchChange(searchEvent, searchValue : string) {
        if (!this.searchChangeObservable) {
            Observable.create(observer => {
                this.searchChangeObservable = observer;
            }).debounceTime(300) // wait 300ms after the last event before emitting last event
              .distinctUntilChanged() // only emit if value is different from previous value
              .subscribe((searchValue) => { this.search(searchValue) });
        }

        this.searchChangeObservable.next(searchValue);
    }

	search(searchValue : string) {
        this.loadingData = true;

        this.searchValue = searchValue;
        
        console.log("set SearchValue: ", this.searchValue);

        this.stockService.searchStockContractors(searchValue)
        .then(data => {
            this.loadingData = false;
            this.results = data;

            if (this.results.length > 0) {
                this.selectedItem = this.results[0];
            } else {
                this.selectedItem = null;
            }
        })
        .catch(error => {
            this.alert.showError('Error', 'Unable to retrieve search results: ' + error);
            this.loadingData = false;
        });
	}

    selectItem(item) {
        this.itemSelected.next(item);
    }

    addNewItem() {
        let loading = this.loadingController.create({
            content: 'Creating Stock Contractor...',
        });

        loading.present();
        this.stockService.addStockContractor(this.searchValue)
            .then(data => {
                loading.dismiss();
                this.toast.create({
                    message: 'Stock Contractor ' + this.searchValue + ' added!',
                    duration: 3000,
                    position: 'middle',
                }).present();

                this.itemSelected.next(data);
            }, error => {
                loading.dismiss();
                this.alert.showError("Stock Contractor Add Error", error);
            });
    }

    getSearchMessage() {
        if (this.searchValue == undefined || this.searchValue.trim().length == 0)
            return "";
        else if (this.results == undefined || this.results.length < 1)
            return "There are no " + this.itemTitle + "s by that name.";

        return "";
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (ev.keyCode === 38 && this.results.length > 0) {
            if (this.results[0] !== this.selectedItem) {
                let index = this.results.indexOf(this.selectedItem);

                this.selectedItem = this.results[index - 1];                
            }
        } else if (ev.keyCode === 40 && this.results.length > 0) {
            if (this.results[this.results.length - 1] !== this.selectedItem) {
                let index = this.results.indexOf(this.selectedItem);

                this.selectedItem = this.results[index*1 + 1];                
            }
        } else if (ev.keyCode === 13 && this.selectedItem != null) {
            this.selectItem(this.selectedItem);
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/settings/search-box.component.v2.ts